import { useState } from "react"
import { X, Trash2, PackageSearch } from "lucide-react"

const DeleteOrderModal = ({ isOpen, onClose, order, onDelete }) => {
    const [reason, setReason] = useState("")
    const [loading, setLoading] = useState(false)

    const reasons = [
        "Duplicate Order",
        "Cancelled by Customer",
        "Fraudulant / Fake",
        "Test Order",
        "Mistake in Entry",
        "Other"
    ]

    const handleDelete = async () => {
        if (reason) {
            setLoading(true)
            await onDelete(order._id, reason)
            setLoading(false)
            onClose()
        }
    }

    if (!isOpen || !order) return null

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
            <div
                className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity"
                onClick={onClose}
            />

            <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200">

                {/* Header */}
                <div className="px-6 py-4 border-b border-red-50 flex justify-between items-center bg-red-50/50">
                    <div>
                        <h3 className="text-lg font-bold text-red-700 flex items-center gap-2">
                            <Trash2 className="w-5 h-5" />
                            Delete Order
                        </h3>
                        <p className="text-xs text-red-600 mt-0.5">Order #{order.orderId} will be permanently removed.</p>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-1.5 rounded-full text-red-400 hover:text-red-600 hover:bg-red-100 transition-colors"
                    >
                        <X className="h-5 w-5" />
                    </button>
                </div>

                <div className="p-6">
                    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6 flex items-start gap-3">
                        <div className="bg-amber-100 p-2 rounded-full shrink-0">
                            <PackageSearch className="w-5 h-5 text-amber-700" />
                        </div>
                        <div>
                            <h4 className="text-sm font-bold text-amber-900">Inventory Restoration</h4>
                            <p className="text-xs text-amber-800 mt-1 leading-relaxed">
                                Deleting this order will <strong>automatically restock</strong> the items to your inventory. This action cannot be undone.
                            </p>
                        </div>
                    </div>

                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-900 mb-3">
                            Select deletion reason:
                        </label>
                        <div className="grid grid-cols-1 gap-2">
                            {reasons.map((r) => (
                                <label
                                    key={r}
                                    className={`relative flex items-center p-3 rounded-xl border cursor-pointer transition-all ${reason === r
                                            ? "border-red-500 bg-red-50/50 ring-1 ring-red-500/20"
                                            : "border-gray-200 hover:border-red-200 hover:bg-gray-50"
                                        }`}
                                >
                                    <input
                                        type="radio"
                                        name="reason"
                                        value={r}
                                        checked={reason === r}
                                        onChange={(e) => setReason(e.target.value)}
                                        className="h-4 w-4 text-red-600 border-gray-300 focus:ring-red-500"
                                    />
                                    <span className={`ml-3 text-sm font-medium ${reason === r ? "text-red-900" : "text-gray-700"}`}>
                                        {r}
                                    </span>
                                </label>
                            ))}
                        </div>
                    </div>

                    <div className="flex gap-3 pt-2">
                        <button
                            onClick={onClose}
                            className="flex-1 px-4 py-2.5 bg-white border border-gray-200 text-gray-700 font-medium rounded-xl hover:bg-gray-50 transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={handleDelete}
                            disabled={!reason || loading}
                            className={`flex-1 px-4 py-2.5 font-medium rounded-xl text-white transition-all shadow-md flex items-center justify-center gap-2 ${reason
                                    ? "bg-red-600 hover:bg-red-700 shadow-red-600/20 transform active:scale-95"
                                    : "bg-gray-300 cursor-not-allowed shadow-none"
                                }`}
                        >
                            {loading ? (
                                <>Deleting...</>
                            ) : (
                                <>
                                    <Trash2 className="w-4 h-4" />
                                    Delete Permanently
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeleteOrderModal
